import { createFileRoute } from "@tanstack/react-router";

import { SettingsShell } from "@/features/settings/settings-shell";

export const Route = createFileRoute("/settings")({
  component: SettingsShell,
});
